export const containerCls = cls`
  bg-f-bg-container
  shadow-[0px_20px_38px_0px_rgba(28, 39,
   49, 0.14)]
  relative mx-auto  w-full max-w-full overflow-hidden
  rounded-xl md:w-[542px]
`

export const descCls = cls`
  text-f-text-secondary  text-sm
`

export const formCls = cls`
  mx-auto w-full max-w-[460px]
`

export const btnCls = cls`
  group flex h-14
  items-center justify-center gap-x-1 font-semibold
`

export const formContainerCls = cls`
  bg-f-bg-container
  shadow-[0px_20px_38px_0px_rgba(28, 39,
  49, 0.14)]
  relative
  mx-auto flex
  max-w-[976px] flex-row-reverse
  gap-x-12 rounded-xl
`
